/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNftTransactionLogListNftTransactionLogData model module.
 * @module model/LogControllerDtoNftTransactionLogListNftTransactionLogData
 * @version 1.0
 */
class LogControllerDtoNftTransactionLogListNftTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoNftTransactionLogListNftTransactionLogData</code>.
     * @alias module:model/LogControllerDtoNftTransactionLogListNftTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoNftTransactionLogListNftTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNftTransactionLogListNftTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNftTransactionLogListNftTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNftTransactionLogListNftTransactionLogData} The populated <code>LogControllerDtoNftTransactionLogListNftTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNftTransactionLogListNftTransactionLogData();

            if (data.hasOwnProperty('nftTransactionNo')) {
                obj['nftTransactionNo'] = ApiClient.convertToType(data['nftTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('exportingGasTransactionNo')) {
                obj['exportingGasTransactionNo'] = ApiClient.convertToType(data['exportingGasTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('importedAt')) {
                obj['importedAt'] = ApiClient.convertToType(data['importedAt'], 'Date');
            }
            if (data.hasOwnProperty('exportedAt')) {
                obj['exportedAt'] = ApiClient.convertToType(data['exportedAt'], 'Date');
            }
            if (data.hasOwnProperty('onchainTxid')) {
                obj['onchainTxid'] = ApiClient.convertToType(data['onchainTxid'], 'String');
            }
            if (data.hasOwnProperty('tradeWalletTransactionNo')) {
                obj['tradeWalletTransactionNo'] = ApiClient.convertToType(data['tradeWalletTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('beforeAccountNo')) {
                obj['beforeAccountNo'] = ApiClient.convertToType(data['beforeAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('beforeAccountEmail')) {
                obj['beforeAccountEmail'] = ApiClient.convertToType(data['beforeAccountEmail'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('transactionLog')) {
                obj['transactionLog'] = ApiClient.convertToType(data['transactionLog'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNftTransactionLogListNftTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNftTransactionLogListNftTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['onchainTxid'] && !(typeof data['onchainTxid'] === 'string' || data['onchainTxid'] instanceof String)) {
            throw new Error("Expected the field `onchainTxid` to be a primitive type in the JSON string but got " + data['onchainTxid']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['beforeAccountEmail'] && !(typeof data['beforeAccountEmail'] === 'string' || data['beforeAccountEmail'] instanceof String)) {
            throw new Error("Expected the field `beforeAccountEmail` to be a primitive type in the JSON string but got " + data['beforeAccountEmail']);
        }
        // ensure the json data is a string
        if (data['transactionLog'] && !(typeof data['transactionLog'] === 'string' || data['transactionLog'] instanceof String)) {
            throw new Error("Expected the field `transactionLog` to be a primitive type in the JSON string but got " + data['transactionLog']);
        }

        return true;
    }


}



/**
 * @member {Number} nftTransactionNo
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['nftTransactionNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} exportingGasTransactionNo
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['exportingGasTransactionNo'] = undefined;

/**
 * @member {Date} importedAt
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['importedAt'] = undefined;

/**
 * @member {Date} exportedAt
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['exportedAt'] = undefined;

/**
 * @member {String} onchainTxid
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['onchainTxid'] = undefined;

/**
 * @member {Number} tradeWalletTransactionNo
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['tradeWalletTransactionNo'] = undefined;

/**
 * @member {Number} transactionType
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['transactionType'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['email'] = undefined;

/**
 * @member {Number} beforeAccountNo
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['beforeAccountNo'] = undefined;

/**
 * @member {String} beforeAccountEmail
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['beforeAccountEmail'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['status'] = undefined;

/**
 * @member {String} transactionLog
 */
LogControllerDtoNftTransactionLogListNftTransactionLogData.prototype['transactionLog'] = undefined;






export default LogControllerDtoNftTransactionLogListNftTransactionLogData;

